module.exports = __webpack_public_path__ + "static/media/warehouse.ded61599.svg";